export default __webpack_public_path__ + "static/media/logo.0e7fc1ad.svg";